import React, { useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
  Badge,
} from "reactstrap"
import { Form } from "react-bootstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faEyeSlash, faTrash } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import { UncontrolledTooltip } from "reactstrap"
import toastr from "toastr"
import TableContainer from "../../components/Common/TableContainer"
import DeleteModal from "components/Common/DeleteModal"
import apiURl from "url"
import { post } from "helpers/api_helper"

const AddMonthlyReport = () => {
  document.title = "Add Monthly Report"
  const navigate = useNavigate()

  // Authorization check
  const loginUser = localStorage.getItem("login_id")
  const CheckLog = localStorage.getItem("role")
  if (CheckLog === "Client") {
    navigate("/monthly-report")
  }

  const [availableBusiness, setAvailableBusiness] = useState([])
  const [accountModal, setAccountModal] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [pdfUrl, setPdfUrl] = useState("")
  const [email, setEmail] = useState("")
  const [editClient, setEditClient] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  // Modal Value
  const [modalData, setModalData] = useState({
    fullname: "",
    businessName: "",
    phone: "",
    email: "",
    fullAddress: "",
    services: "",
    websiteLink: "",
    businessLocations: "",
    logo: null,
    password: "",
  })

  // Handle form input changes
  const handleModalInputChange = e => {
    const { name, value } = e.target
    setModalData(prev => ({ ...prev, [name]: value }))
  }

  const handleLogoChange = e => {
    const file = e.target.files[0]
    if (file) {
      setModalData(prev => ({ ...prev, logo: file }))
    }
  }

  // Form Data
  const [formData, setFormData] = useState({
    client_id: "",
    user_id: loginUser,
    businessName: "",
    reportDate: "",
    profileViews: "",
    overview: "",
    websiteClicks: "",
    calls: "",
    directions: "",
    profileViewsImage: null,
    overviewImage: null,
    callsImage: null,
    directionsImage: null,
    websiteClicksImage: null,
    gbpKeywords: [{ keyword: "", position: "", image: null }],
    websiteKeywords: [{ keyword: "", position: "", image: null }],
    ongoingPostingImage: null,
    optimizedServiceSectionImage: null,
    productSectionOptimizationImage: null,
    mapCitationsImage: null,
    submittedInGSCImage: null,
    seoActivities: [
      { offpageSEO: "Local Citations", status: "" },
      { offpageSEO: "Map Citations", status: "" },
      { offpageSEO: "GBP Posting", status: "" },
      { offpageSEO: "GBP Product Optimization", status: "" },
      { offpageSEO: "Website Blog", status: "" },
      { offpageSEO: "Submitted in Google", status: "" },
    ],
  })

  // Fetch all clients
  const fetchAllClients = async () => {
    try {
      const response = await fetch(`${apiURl}/api/clients/fetchClients`)
      const json = await response.json()
      if (response.status === 200) {
        setAvailableBusiness(
          json.clients
            .filter(user => user.status_ === "Active")
            .map(user => ({
              value: user.id,
              label: user.business_name,
            }))
        )
      }
    } catch (err) {
      console.error("Fetch Error:", err)
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleFileChange = e => {
    const { name, files } = e.target
    setFormData({ ...formData, [name]: files[0] })
  }

  const handleKeywordChange = (type, index, e) => {
    const { name, value } = e.target
    const keywords = [...formData[`${type}Keywords`]]
    keywords[index][name] = value
    setFormData({ ...formData, [`${type}Keywords`]: keywords })
  }

  const handleKeywordImageChange = (type, index, e) => {
    const keywords = [...formData[`${type}Keywords`]]
    keywords[index].image = e.target.files[0]
    setFormData({ ...formData, [`${type}Keywords`]: keywords })
  }

  const addKeyword = type => {
    setFormData({
      ...formData,
      [`${type}Keywords`]: [
        ...formData[`${type}Keywords`],
        { keyword: "", position: "", image: null },
      ],
    })
  }

  const removeKeyword = (type, index) => {
    const keywords = [...formData[`${type}Keywords`]]
    keywords.splice(index, 1)
    setFormData({
      ...formData,
      [`${type}Keywords`]: keywords.length
        ? keywords
        : [{ keyword: "", position: "", image: null }],
    })
  }

  const handleSEOChange = (index, e) => {
    const { name, value } = e.target
    const seoActivities = [...formData.seoActivities]
    seoActivities[index][name] = value
    setFormData({ ...formData, seoActivities })
  }

  const addSEOActivity = () => {
    setFormData({
      ...formData,
      seoActivities: [
        ...formData.seoActivities,
        { offpageSEO: "", status: "" },
      ],
    })
  }

  const removeSEOActivity = index => {
    const seoActivities = [...formData.seoActivities]
    seoActivities.splice(index, 1)
    setFormData({
      ...formData,
      seoActivities: seoActivities.length
        ? seoActivities
        : [{ offpageSEO: "", status: "" }],
    })
  }

  const handleSendEmail = async () => {
    if (!email.trim()) {
      toastr.error("Email is required")
      return
    }
    try {
      const response = await fetch(`${apiURl}/api/Monthlyreports/send-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          pdfPath: pdfUrl,
        }),
      })
      const result = await response.json()
      if (response.ok) {
        toastr.success("Email sent successfully!")
        setEmail("")
        setPdfModal(false)
      } else {
        toastr.error(result.message || "Failed to send email")
      }
    } catch (error) {
      console.error("Error sending email:", error)
      toastr.error("Failed to send email")
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    const data = new FormData()
    for (const key in formData) {
      if (key === "gbpKeywords" || key === "websiteKeywords") {
        const isGBP = key === "gbpKeywords"
        const appendKey = isGBP ? "gbpKeyword" : "websiteKeyword"
        data.append(
          key,
          JSON.stringify(
            formData[key].map(k => ({
              keyword: k.keyword,
              position: k.position,
            }))
          )
        )
        formData[key].forEach((k, index) => {
          if (k.image) data.append(`${appendKey}Image${index}`, k.image)
        })
      } else if (key === "seoActivities") {
        data.append("seoActivities", JSON.stringify(formData.seoActivities))
      } else if (formData[key] instanceof File) {
        data.append(key, formData[key])
      } else {
        data.append(key, formData[key])
      }
    }

    try {
      const response = await fetch(`${apiURl}/api/Monthlyreports`, {
        method: "POST",
        body: data,
      })

      const result = await response.json()

      if (response.ok) {
        const encodedPdfPath = encodeURI(result.pdfPath)
        setPdfUrl(encodedPdfPath)
        setPdfModal(true)
        toastr.success("Report generated successfully!")
      } else {
        toastr.error(result.message || "Error generating report.")
      }
    } catch (error) {
      console.error("Error generating report:", error)
      toastr.error("Error generating report.")
    } finally {
      setIsLoading(false) // Stop loading
    }
  }

  useEffect(() => {
    fetchAllClients()
  }, [])

  // Handle save (create or update)
  const handleSaveClient = async e => {
    e.preventDefault()

    // Form validation
    if (!modalData.fullname.trim()) return toastr.error("Full Name is required")
    if (!modalData.businessName.trim())
      return toastr.error("Business Name is required")
    if (!modalData.phone.trim()) return toastr.error("Phone is required")
    if (!modalData.email.trim()) return toastr.error("Email is required")
    if (!modalData.password.trim() && !editClient)
      return toastr.error("Password is required")

    const method = editClient ? "PUT" : "POST"
    const url = editClient
      ? `${apiURl}/api/clients/edit-client/${editClient.id}`
      : `${apiURl}/api/clients/add-client`

    const formPayload = new FormData()
    formPayload.append("fullname", modalData.fullname)
    formPayload.append("businessName", modalData.businessName)
    formPayload.append("phone", modalData.phone)
    formPayload.append("email", modalData.email)
    formPayload.append("fullAddress", modalData.fullAddress)
    formPayload.append("services", modalData.services)
    formPayload.append("websiteLink", modalData.websiteLink)
    formPayload.append("businessLocations", modalData.businessLocations)
    formPayload.append("password", modalData.password || "")

    if (modalData.logo) {
      formPayload.append("logo", modalData.logo)
    }

    try {
      const response = await fetch(url, {
        method,
        body: formPayload,
      })

      const json = await response.json()

      if (response.ok) {
        toastr.success(editClient ? "Client updated!" : "Client added!")
        fetchAllClients()
        setAccountModal(false)
        setEditClient(null)
        setModalData({
          fullname: "",
          businessName: "",
          phone: "",
          email: "",
          fullAddress: "",
          services: "",
          websiteLink: "",
          businessLocations: "",
          logo: null,
          password: "",
        })
      } else {
        toastr.error(json.message || "Failed to save client")
      }
    } catch (err) {
      console.error("Save Error:", err)
      toastr.error("Failed to save client")
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="SEO Monthly Report Generator" />
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit} className="mt-2">
                {/* Business Name and Report Date */}
                <Row>
                  <Col lg="6">
                    <Label htmlFor="businessName">Business Name</Label>
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <Select
                        options={availableBusiness}
                        value={availableBusiness.find(
                          option => option.value === formData.businessName
                        )}
                        onChange={selectedOption =>
                          setFormData(prev => ({
                            ...prev,
                            businessName: selectedOption?.value || "",
                            client_id: selectedOption?.value || "",
                          }))
                        }
                        placeholder="Select business..."
                        className="react-select flex-grow-1"
                        classNamePrefix="select"
                      />
                      <Button
                        className="btn btn-sm btn-primary"
                        onClick={() => {
                          setModalData({
                            fullname: "",
                            businessName: "",
                            phone: "",
                            email: "",
                            fullAddress: "",
                            services: "",
                            websiteLink: "",
                            businessLocations: "",
                            logo: null,
                            password: "",
                          })
                          setEditClient(null)
                          setAccountModal(true)
                        }}
                      >
                        <i className="fa fa-fw fa-plus" />
                      </Button>
                    </div>
                  </Col>
                  <Col lg="6">
                    <div className="mb-3">
                      <Label html for="reportDate">
                        Report Date
                      </Label>
                      <InputGroup>
                        <Flatpickr
                          name="reportDate"
                          id="reportDate"
                          value={formData.reportDate}
                          onChange={([selectedDate], dateStr) => {
                            setFormData(prev => ({
                              ...prev,
                              reportDate: dateStr,
                            }))
                          }}
                          className="form-control d-block"
                          placeholder="dd M,yyyy"
                          required
                          options={{
                            allowInput: true,
                            altFormat: "F j, Y",
                            dateFormat: "Y-m-d",
                          }}
                        />
                      </InputGroup>
                    </div>
                  </Col>
                </Row>

                {/* GBP Performance */}
                <div className="border-top pt-4">
                  <h2 className="h4 font-weight-semibold text-dark mb-4">
                    GBP Performance
                  </h2>
                  <Row>
                    {[
                      {
                        label: "Profile Views",
                        name: "profileViews",
                        imageName: "profileViewsImage",
                      },
                      {
                        label: "Overview Interactions",
                        name: "overview",
                        imageName: "overviewImage",
                      },
                      {
                        label: "Website Clicks",
                        name: "websiteClicks",
                        imageName: "websiteClicksImage",
                      },
                      {
                        label: "Calls",
                        name: "calls",
                        imageName: "callsImage",
                      },
                      {
                        label: "Directions",
                        name: "directions",
                        imageName: "directionsImage",
                      },
                    ].map((field, index) => (
                      <React.Fragment key={index}>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label htmlFor={field.name}>{field.label}</Label>
                            <Input
                              type="number"
                              name={field.name}
                              id={field.name}
                              value={formData[field.name]}
                              onChange={handleInputChange}
                              className="form-control"
                              onWheel={e => e.currentTarget.blur()}
                              required
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label htmlFor={field.imageName}>
                              {field.label} Image
                            </Label>
                            <Input
                              type="file"
                              name={field.imageName}
                              id={field.imageName}
                              onChange={handleFileChange}
                              className="form-control"
                              accept="image/*"
                            />
                          </div>
                        </Col>
                      </React.Fragment>
                    ))}
                  </Row>
                </div>

                {/* GBP Ranking Keywords */}
                <div className="border-top pt-4">
                  <h2 className="h4 font-weight-semibold text-dark mb-4">
                    GBP Ranking Keywords
                  </h2>
                  {formData.gbpKeywords.map((keyword, index) => (
                    <Row key={index} className="mb-3 align-items-center">
                      <Col lg="4">
                        <div className="mb-3">
                          <Label htmlFor={`gbpKeyword${index}`}>Keyword</Label>
                          <Input
                            type="text"
                            name="keyword"
                            id={`gbpKeyword${index}`}
                            value={keyword.keyword}
                            onChange={e => handleKeywordChange("gbp", index, e)}
                            className="form-control"
                            required
                          />
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label htmlFor={`gbpPosition${index}`}>
                            Position
                          </Label>
                          <Input
                            type="text"
                            name="position"
                            id={`gbpPosition${index}`}
                            value={keyword.position}
                            onChange={e => handleKeywordChange("gbp", index, e)}
                            className="form-control"
                            required
                          />
                        </div>
                      </Col>
                      <Col lg="4">
                        <div className="mb-3">
                          <Label htmlFor={`gbpKeywordImage${index}`}>
                            Image
                          </Label>
                          <Input
                            type="file"
                            name={`gbpKeywordImage${index}`}
                            id={`gbpKeywordImage${index}`}
                            onChange={e =>
                              handleKeywordImageChange("gbp", index, e)
                            }
                            className="form-control"
                            accept="image/*"
                          />
                        </div>
                      </Col>
                      <Col lg="1">
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          onClick={() => removeKeyword("gbp", index)}
                          className="mt-3"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="button"
                    onClick={() => addKeyword("gbp")}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fa fa-fw fa-plus me-1" /> Add GBP Keyword
                  </Button>
                </div>

                {/* Website Ranking Keywords */}
                <div className="border-top pt-4">
                  <h2 className="h4 font-weight-semibold text-dark mb-4">
                    Website Ranking Keywords
                  </h2>
                  {formData.websiteKeywords.map((keyword, index) => (
                    <Row key={index} className="mb-3 align-items-center">
                      <Col lg="4">
                        <div className="mb-3">
                          <Label htmlFor={`websiteKeyword${index}`}>
                            Keyword
                          </Label>
                          <Input
                            type="text"
                            name="keyword"
                            id={`websiteKeyword${index}`}
                            value={keyword.keyword}
                            onChange={e =>
                              handleKeywordChange("website", index, e)
                            }
                            className="form-control"
                            required
                          />
                        </div>
                      </Col>
                      <Col lg="3">
                        <div className="mb-3">
                          <Label htmlFor={`websitePosition${index}`}>
                            Position
                          </Label>
                          <Input
                            type="text"
                            name="position"
                            id={`websitePosition${index}`}
                            value={keyword.position}
                            onChange={e => {
                              handleKeywordChange("website", index, e)
                            }}
                            className="form-control"
                            required
                          />
                        </div>
                      </Col>
                      <Col lg="4">
                        <div className="mb-3">
                          <Label htmlFor={`websiteKeywordImage${index}`}>
                            Image
                          </Label>
                          <Input
                            type="file"
                            name={`websiteKeywordImage${index}`}
                            id={`websiteKeywordImage${index}`}
                            onChange={e =>
                              handleKeywordImageChange("website", index, e)
                            }
                            className="form-control"
                            accept="image/*"
                          />
                        </div>
                      </Col>
                      <Col lg="1">
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          onClick={() => removeKeyword("website", index)}
                          className="mt-3"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="button"
                    onClick={() => addKeyword("website")}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fa fa-fw fa-plus me-1" /> Add Website Keyword
                  </Button>
                </div>

                {/* Additional Images */}
                <div className="border-top pt-4">
                  <h2 className="h4 font-weight-semibold text-dark mb-4">
                    Additional Images
                  </h2>
                  <Row>
                    {[
                      {
                        label: "Ongoing Posting Image",
                        name: "ongoingPostingImage",
                      },
                      {
                        label: "Optimized Service Section Image",
                        name: "optimizedServiceSectionImage",
                      },
                      {
                        label: "Product Section Optimization Image",
                        name: "productSectionOptimizationImage",
                      },
                      {
                        label: "Map Citations Image",
                        name: "mapCitationsImage",
                      },
                      {
                        label: "Submitted in GSC Image",
                        name: "submittedInGSCImage",
                      },
                    ].map((field, index) => (
                      <Col lg="6" key={index}>
                        <div className="mb-3">
                          <Label htmlFor={field.name}>{field.label}</Label>
                          <Input
                            type="file"
                            name={field.name}
                            id={field.name}
                            onChange={handleFileChange}
                            className="form-control"
                            accept="image/*"
                          />
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>

                {/* Offpage & Onpage SEO */}
                <div className="border-top pt-4">
                  <h2 className="h4 font-weight-semibold text-dark mb-4">
                    Offpage & Onpage SEO Actions
                  </h2>
                  {formData.seoActivities.map((activity, index) => (
                    <Row key={index} className="mb-3 align-items-center">
                      <Col lg="5">
                        <div className="mb-3">
                          <Label htmlFor={`offpageSEO${index}`}>
                            Offpage SEO
                          </Label>
                          <Input
                            type="text"
                            name="offpageSEO"
                            id={`offpageSEO${index}`}
                            value={activity.offpageSEO}
                            onChange={e => handleSEOChange(index, e)}
                            className="form-control"
                            required
                          />
                        </div>
                      </Col>
                      <Col lg="5">
                        <div className="mb-3">
                          <Label htmlFor={`status${index}`}>Status</Label>
                          <Input
                            type="text"
                            name="status"
                            id={`status${index}`}
                            value={activity.status}
                            onChange={e => handleSEOChange(index, e)}
                            className="form-control"
                            required
                          />
                        </div>
                      </Col>
                      <Col lg="2">
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          onClick={() => removeSEOActivity(index)}
                          className="mt-3"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </Button>
                      </Col>
                    </Row>
                  ))}
                  <Button
                    type="button"
                    onClick={addSEOActivity}
                    className="btn btn-sm btn-info"
                  >
                    <i className="fa fa-fw fa-plus me-1" /> Add SEO Activity
                  </Button>
                </div>

                <div className="mt-4">
                  <Button
                    type="submit"
                    color="success"
                    className="btn btn-success w-100"
                    disabled={isLoading}
                  >
                    Generate Report
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
          {isLoading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div className="text-center text-white">
                <i
                  className="fas fa-spinner fa-spin"
                  style={{ fontSize: "3rem", marginBottom: "1rem" }}
                />
                <div>Generating Report...</div>
              </div>
            </div>
          )}
        </Container>
      </div>

      <Modal
        isOpen={accountModal}
        toggle={() => setAccountModal(!accountModal)}
        size="lg"
        centered
      >
        <Form onSubmit={handleSaveClient}>
          <ModalHeader toggle={() => setAccountModal(!accountModal)}>
            {editClient ? "Edit Client" : "Create New Client"}
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Full Name *</Label>
                  <Input
                    type="text"
                    name="fullname"
                    value={modalData.fullname}
                    onChange={handleModalInputChange}
                    placeholder="Enter full name"
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Business Name *</Label>
                  <Input
                    type="text"
                    name="businessName"
                    value={modalData.businessName}
                    onChange={handleModalInputChange}
                    placeholder="Enter business name"
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Phone *</Label>
                  <Input
                    type="tel"
                    name="phone"
                    value={modalData.phone}
                    onChange={handleModalInputChange}
                    placeholder="Enter phone number"
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Email *</Label>
                  <Input
                    type="email"
                    name="email"
                    value={modalData.email}
                    onChange={handleModalInputChange}
                    placeholder="Enter email"
                    required
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Password *</Label>
                  <InputGroup>
                    <Input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={modalData.password}
                      onChange={handleModalInputChange}
                      placeholder="Enter password"
                      required={!editClient}
                    />
                    <InputGroupText
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      <FontAwesomeIcon
                        icon={showPassword ? faEyeSlash : faEye}
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Full Address</Label>
                  <Input
                    type="text"
                    name="fullAddress"
                    value={modalData.fullAddress}
                    onChange={handleModalInputChange}
                    placeholder="Enter full address"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Services</Label>
                  <Input
                    type="text"
                    name="services"
                    value={modalData.services}
                    onChange={handleModalInputChange}
                    placeholder="Enter services"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Website Link</Label>
                  <Input
                    type="url"
                    name="websiteLink"
                    value={modalData.websiteLink}
                    onChange={handleModalInputChange}
                    placeholder="Enter website link"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Business Locations</Label>
                  <Input
                    type="text"
                    name="businessLocations"
                    value={modalData.businessLocations}
                    onChange={handleModalInputChange}
                    placeholder="Enter business locations"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Logo</Label>
                  <Input
                    type="file"
                    name="logo"
                    accept="image/*"
                    onChange={handleLogoChange}
                  />
                </FormGroup>
                {modalData.logo && (
                  <div className="mb-3">
                    <img
                      src={
                        typeof modalData.logo === "string"
                          ? `${apiURl}${modalData.logo}`
                          : URL.createObjectURL(modalData.logo)
                      }
                      alt="Preview"
                      style={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                )}
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setModalData({
                  fullname: "",
                  businessName: "",
                  phone: "",
                  email: "",
                  fullAddress: "",
                  services: "",
                  websiteLink: "",
                  businessLocations: "",
                  logo: null,
                  password: "",
                })
                setEditClient(null)
                setAccountModal(false)
              }}
            >
              Cancel
            </Button>
            <Button color="primary" type="submit">
              {editClient ? "Update Client" : "Create Client"}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      <Modal
        isOpen={pdfModal}
        toggle={() => {
          setPdfModal(false)
          navigate("/monthly-report")
        }}
        size="xl"
        centered
      >
        <ModalHeader toggle={() => setPdfModal(!pdfModal)}>
          View Generated Report
        </ModalHeader>
        <ModalBody>
          <iframe
            src={pdfUrl}
            style={{ width: "100%", height: "450px", border: "none" }}
            title="PDF Report"
          />
          <FormGroup className="mt-3">
            <Label for="emailInput">Send Report to Email</Label>
            <Input
              type="email"
              id="emailInput"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter recipient email"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setPdfModal(false)
              setEmail("")
              setPdfUrl("")
              navigate("/monthly-report")
            }}
          >
            Close
          </Button>
          <Button
            color="primary"
            onClick={handleSendEmail}
            disabled={!email.trim()}
          >
            Send Email
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default AddMonthlyReport
